import { render, staticRenderFns } from "./blackList.vue?vue&type=template&id=ee895936&scoped=true&"
import script from "./blackList.vue?vue&type=script&lang=js&"
export * from "./blackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee895936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee895936')) {
      api.createRecord('ee895936', component.options)
    } else {
      api.reload('ee895936', component.options)
    }
    module.hot.accept("./blackList.vue?vue&type=template&id=ee895936&scoped=true&", function () {
      api.rerender('ee895936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/blackList.vue"
export default component.exports